import { apiClient } from './client';
import type {
  Collection,
  CollectionCreateInput,
  CollectionUpdateInput,
} from '../../types/entities';

export const collectionsApi = {
  /**
    * Get all collections for a tenant
    * GET /tenants/:tenantSlug/collections
    */
  getAllForTenant: async (tenantSlug: string): Promise<Collection[]> => {
    return apiClient.get<Collection[]>(`/tenants/${tenantSlug}/collections`);
  },

  /**
    * Get a single collection by ID
    * GET /tenants/:tenantSlug/collections/:id
    */
  getById: async (tenantSlug: string, id: number): Promise<Collection> => {
    return apiClient.get<Collection>(`/tenants/${tenantSlug}/collections/${id}`);
  },

  /**
    * Create a new collection
    * POST /tenants/:tenantSlug/collections
    */
  create: async (
    tenantSlug: string,
    data: CollectionCreateInput
  ): Promise<Collection> => {
    return apiClient.post<Collection>(`/tenants/${tenantSlug}/collections`, data);
  },

  /**
    * Update a collection
    * PUT /tenants/:tenantSlug/collections/:id
    */
  update: async (
    tenantSlug: string,
    id: number,
    data: CollectionUpdateInput
  ): Promise<Collection> => {
    return apiClient.put<Collection>(
      `/tenants/${tenantSlug}/collections/${id}`,
      data
    );
  },

  /**
    * Delete a collection
    * DELETE /tenants/:tenantSlug/collections/:id
    */
  delete: async (tenantSlug: string, id: number): Promise<void> => {
    return apiClient.delete<void>(`/tenants/${tenantSlug}/collections/${id}`);
  },
};
